<div class="chart-shell">
  <p-chart type="bar" [data]="data" [options]="options" style="width: 100%; height: 100%"></p-chart>
</div>
